import { createRoot } from 'react-dom/client'
import { Provider } from "react-redux";
import getStore from "./system/store";
import Routes from "./routes";
import { logger } from "./system/utils";
import { Settings } from "luxon";

logger("Initializing...");

// Configure the time zone
Settings.defaultZone = "America/Chicago";

createRoot(document.getElementById('root')!).render(
  <Provider store={getStore()}>
    <Routes />
  </Provider>
)
